/**
 * Mapeamento de features antigas para novas (consolidadas)
 *
 * Este arquivo fornece compatibilidade durante a transição do sistema de permissões.
 * Features antigas fragmentadas (ex: appointments_view, appointments_create) foram
 * consolidadas em features únicas (ex: appointments com view/create/update/delete).
 */

export const FEATURE_MAPPING: Record<string, string> = {
  // Calendar
  calendar_view: 'calendar',

  // Appointments
  appointments_view: 'appointments',
  appointments_create: 'appointments',
  appointments_update: 'appointments',
  appointments_delete: 'appointments',

  // Patients (unified pets + owners)
  patients_view: 'patients',
  patients_create: 'patients',
  patients_update: 'patients',
  patients_delete: 'patients',

  // Legacy mappings for backward compatibility
  pets_view: 'patients',
  pets_create: 'patients',
  pets_update: 'patients',
  pets_delete: 'patients',
  owners_view: 'patients',
  owners_create: 'patients',
  owners_update: 'patients',
  owners_delete: 'patients',

  // Medical Records
  medical_records_view: 'medical_records',
  medical_records_create: 'medical_records',
  medical_records_update: 'medical_records',
  medical_records_delete: 'medical_records',

  // Applications (canonical) + vaccines legacy aliases
  applications: 'applications',
  applications_view: 'applications',
  applications_create: 'applications',
  applications_update: 'applications',
  applications_delete: 'applications',
  vaccines: 'applications',
  vaccines_view: 'applications',
  vaccines_create: 'applications',
  vaccines_update: 'applications',
  vaccines_delete: 'applications',

  // Admin Users
  admin_users_view: 'admin_users',
  admin_users_manage: 'admin_users',

  // Admin Permissions
  admin_permissions_view: 'admin_permissions',
  admin_permissions_manage: 'admin_permissions',

  // Admin Settings
  admin_settings: 'admin_settings',

  // WhatsApp
  whatsapp_config: 'whatsapp_config',

  // Catalog
  catalog_view: 'catalog',
  catalog_create: 'catalog',
  catalog_update: 'catalog',
  catalog_delete: 'catalog',

  // Audit Logs
  audit_logs_view: 'audit_logs',

  // Stock
  stock_view: 'stock',
  stock_create: 'stock',
  stock_update: 'stock',
  stock_delete: 'stock',

  // Sales
  sales_view: 'sales',
  sales_create: 'sales',
  sales_update: 'sales',
  sales_delete: 'sales',

  // Purchases
  purchases_view: 'purchases',
  purchases_create: 'purchases',
  purchases_update: 'purchases',
  purchases_delete: 'purchases',

  // Reports (permission from features.can_view for feature "reports")
  reports_view: 'reports',

  // Grooming
  grooming_view: 'grooming',
  grooming_create: 'grooming',
  grooming_update: 'grooming',
  grooming_delete: 'grooming',

  // Grooming (frontend "resource" aliases)
  // Some UI surfaces historically used table-ish names; permissions are keyed by feature `grooming`.
  grooming_sessions: 'grooming',
  grooming_reports: 'grooming',

  // Grooming Packages
  grooming_packages_view: 'grooming_packages',
  grooming_packages_manage: 'grooming_packages',

  // Terms
  terms_view: 'terms',
  terms_create: 'terms',
  terms_update: 'terms',
  terms_delete: 'terms',

  // Novas features (já consolidadas)
  user_access: 'user_access',
  user_permission: 'user_permission',
  manage_clinic: 'manage_clinic',
};

/**
 * Converte feature antiga para nova
 */
export function normalizeFeatureName(feature: string): string {
  return FEATURE_MAPPING[feature] || feature;
}

/**
 * Converte ação 'edit' para 'update' (padrão do banco)
 */
export function normalizeAction(action: 'view' | 'create' | 'edit' | 'delete'): 'view' | 'create' | 'update' | 'delete' {
  return action === 'edit' ? 'update' : action;
}
